import { css } from "styled-components";
import { FlexMixin, FontMixin } from "../../../../../../../../../styles/common/mixins/helpers.styled.js";
import { Padding } from "../../../../../../../../../styles/common/mixins/logical.styled.js";
const veciSearcherButtonStyles = {
    SearcherWrapper: ()=>css``,
    NumberTextWrapper: ()=>css``,
    SearcherWrapperButton: ()=>css`
		${FontMixin({
            size: 'base',
            weight: 'semiBold',
            height: 'base'
        })}
		${Padding({
            x: '20px'
        })};
	`,
    SearcherItemButtonDesktop: ()=>css`
		${FlexMixin({
            align: 'center'
        })}
	`
};
export default veciSearcherButtonStyles;

//# sourceMappingURL=veci.js.map